export default __webpack_public_path__ + "static/media/sv.1dfe9aaa.svg";